import { makeAutoObservable } from 'mobx';

import ImageStore from './ImageStore';
import liveUsersStore from './LiveUsersStore';
import MapStore from './MapStore';
import MessageStore from './MessageStore';
import RtvUiStore from './RtvUiStore';
import TelemetryStore from './TelemetryStore';
import WeatherDataStore from './WeatherDataStore';

export type TelemetrySource = 'drone' | 'multispectral';

class CampaignRootStore {
  telemetryStore: TelemetryStore;

  weatherDataStore: WeatherDataStore;

  mapStore: MapStore;

  imageStore: ImageStore;

  rtvUiStore: RtvUiStore;

  messageStore: MessageStore;

  liveUsersStore: typeof liveUsersStore;

  constructor() {
    makeAutoObservable(this);
    this.telemetryStore = new TelemetryStore(this);
    this.weatherDataStore = new WeatherDataStore(this);
    this.mapStore = new MapStore(this);
    this.imageStore = new ImageStore(this);
    this.rtvUiStore = new RtvUiStore(this);
    this.messageStore = new MessageStore(this);
    this.liveUsersStore = liveUsersStore;
  }
  // TODO: Add cleanup logic for stores
}
const campaignRootStore = new CampaignRootStore();
export { CampaignRootStore, campaignRootStore };
